<template>
  <div>
    <b-form-group
      label="Tutar"
      label-for="amount"
    >
      <validation-provider
        #default="{ errors }"
        name="Tutar"
        rules="required"
      >
        <b-input-group>
          <cleave
            id="amount"
            v-model="dataItem.amount"
            class="form-control"
            :raw="true"
            :options="options.float"
            placeholder="Tutar"
          />
          <b-input-group-append>
            <currency-select />
          </b-input-group-append>
        </b-input-group>
        <small class="text-danger">{{ errors[0] }}</small>
      </validation-provider>
    </b-form-group>
    <b-alert
      :show="dataItem.amount > dataItem.former_amount"
      variant="danger"
    >
      <div class="alert-body">
        Transfer işlemi için girilen tutar {{ dataItem.former_amount | toCurrency }} TL'den büyük olamaz.
      </div>
    </b-alert>
  </div>
</template>

<script>
import { ValidationProvider, localize } from 'vee-validate'
import {
  BFormGroup, BInputGroup, BInputGroupAppend, BAlert,
} from 'bootstrap-vue'
import { required } from '@validations'
import Cleave from 'vue-cleave-component'
import CurrencySelect from '@/views/Admin/Account_activities/Components/TransferModal/elements/CurrencySelect.vue'

export default {
  name: 'Amount',
  components: {
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BAlert,
    CurrencySelect,
    ValidationProvider,
    Cleave,
  },
  data() {
    return {
      required,
      options: {
        float: {
          numeral: true,
          numeralDecimalMark: ',',
          delimiter: '.',
        },
      },
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['accountActivities/transferDataItem']
    },
  },
  created() {
    localize('tr')
  },
}
</script>
